import type { RoleRepository } from '#/domain/role/RoleRepository'
import type { Role } from '#/domain/role/Role'
import type { HttpClientPort } from '#/infrastructure/persistence/HttpClientPort'
import { toDomainList, type RoleResponseDto } from './RoleDto'

export class HttpRoleRepository implements RoleRepository {
  constructor(private readonly http: HttpClientPort) {}

  async findAll(): Promise<Role[]> {
    const raw = await this.http.get<RoleResponseDto[]>('auth0/role')
    return toDomainList(raw)
  }
}
